import { render } from "./WorkbenchPage.vue?vue&type=template&id=3212b130"
import script from "./WorkbenchPage.vue?vue&type=script&lang=js"
export * from "./WorkbenchPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__